import LoginForm from './LoginForm/LoginForm.vue';
import SignUpForm from './SignUpForm/SignUpForm.vue';
// import SignUpForm from '../SignUpForm/SignUpForm.vue';
export default {
  components: {
    LoginForm,
    SignUpForm,
  },
};
